<!--
대금상환 비고 수정 모달 — 총괄 · 센터 공용 2필드 (TASK-161 결정 3 ⓒ → 사이클 14 #12 B 안 공용 모달, 시안 2026-10-09-6th)
------------------------------------
 - 페이지당 1 인스턴스. 카드 비고 띠 / 「+ 비고」 · 「비고 수정」 링크가 open(row, focus) 로 데이터 주입
     row   = 대금상환 목록 page.cod_rows[id] (CodPaymentIndexTrait::codRowsJson) / 구매요청 목록 page.cod_memo_rows[id]
     focus = 'req' | 'paid' — 누른 비고 칸에 커서가 먼저 간다
 - 컨텍스트 4줄 (해외오더번호 · 상태 · 회원사 · 대금상환금액 (+ 창고지급(실제))) + 대금상환비고 · 창고지급비고 textarea + 힌트 + 닫기/저장
     사이클 16 #27: 컨텍스트 = 공용 app-buy-order-ctx (대금상환금액 큰 글자 · 상태 라벨 .boc-pill · 오더번호 복사)
 - 저장 = 비고 2개 한 번에 PATCH (빈 값 = 지움, 무변경이면 서버가 기록 생략)
     region-id 있음 = PATCH /regions/{regionId}/cod-payments/{id}/memo (센터 화면) / 없음 = PATCH /admin/cod-payments/{id}/memo (총괄 · 구매요청)
 - 서버 = CodPayment\UpdateLogic (취소 제외 전 상태 · 신로깅 비고 diff logUpdated)
 - E2E 셀렉터 = .cdp-memo-popup · .cdp-req-memo-input · .cdp-paid-memo-input · .cdp-memo-submit
 - 성공 = 서버 msg alert 후 새로고침
-->
<template>
    <div ref="modal" uk-modal esc-close="false" bg-close="false" class="cdp-popup cdp-memo-popup">
        <div class="uk-modal-dialog uk-modal-body uk-text-left">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <h3 class="uk-modal-title">대금상환 비고 수정</h3>

            <!-- 사이클 16 #27 — 컨텍스트 헤더 (공용 app-buy-order-ctx — E2E 셀렉터 .cdp-memo-ctx (루트) · __code (오더번호) · __state (상태 라벨) 보존) -->
            <app-buy-order-ctx v-if="row" class="cdp-memo-ctx" code-class="cdp-memo-ctx__code"
                               :code="row.buy_order_code || ''" :items="ctxItems"></app-buy-order-ctx>

            <div class="cdp-memo-field cdp-memo-field--req">
                <label class="cdp-memo-field__label">대금상환비고 <span class="cdp-memo-field__help">총괄이 요청 때 남기는 메모 — 창고도 수정 가능</span></label>
                <textarea ref="reqMemo" class="uk-textarea cdp-req-memo-input" rows="3" v-model="inputReqMemo" placeholder="대금상환비고"></textarea>
            </div>

            <div class="cdp-memo-field cdp-memo-field--paid">
                <label class="cdp-memo-field__label">창고지급비고 <span class="cdp-memo-field__help">창고가 지급 때 남기는 메모 — 총괄도 수정 가능</span></label>
                <textarea ref="paidMemo" class="uk-textarea cdp-paid-memo-input" rows="3" v-model="inputPaidMemo" placeholder="창고지급비고"></textarea>
            </div>

            <div class="cdp-memo-foot">
                <span class="cdp-memo-foot__hint">변경 내용은 대금상환 상세의 변경 히스토리에 남습니다.</span>
                <span class="cdp-memo-foot__btns">
                    <button class="uk-button uk-button-default uk-modal-close" type="button">닫기</button>
                    <button class="uk-button uk-button-primary cdp-memo-submit" type="button" :disabled="busy" @click="submit">저장</button>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import CodPopupMixin from './popup-mixin';

    export default {
        mixins: [CodPopupMixin],
        props: {
            // csrf-token
            csrfToken: String,

            // 센터ID (센터 화면 라우트 — 없으면 총괄 API)
            regionId: {
                type: [String, Number],
                default: '',
            },
        },
        data: function () {
            return {
                inputReqMemo: '',
                inputPaidMemo: '',
            };
        },
        computed: {
            hasPaidAmount() {
                return !! this.row && this.normalize(this.row.paid_amount) !== '';
            },

            // 컨텍스트 헤더 키-값 (사이클 16 #27 — 상태 · 회원사 / 대금상환금액 큰 글자 (+ 창고지급(실제)))
            ctxItems() {
                if (! this.row) {
                    return [];
                }
                // 회원사 = 닉 · 사서함 중 있는 값만 (창고 역할 세션은 서버가 user_nick 키를 보내지 않음 — TASK-175 ⑤)
                let user_text = [this.row.user_nick, this.row.user_mailbox]
                    .filter((v) => v !== undefined && v !== null && String(v) !== '')
                    .join(' · ');
                let items = [
                    {k: '상태', v: this.row.state_text, pill: this.row.state, cls: 'cdp-memo-ctx__state'},
                    {k: '회원사', v: user_text},
                    {k: '대금상환금액', v: this.reqAmountText, big: true, cls: 'cdp-memo-ctx__money'},
                ];
                if (this.hasPaidAmount) {
                    items.push({k: '창고지급(실제)', v: this.paidAmountText});
                }
                return items;
            },

            submitUrl() {
                if (! this.row) {
                    return '';
                }
                let region = this.normalize(this.regionId);
                return region !== ''
                    ? '/regions/' + region + '/cod-payments/' + this.row.id + '/memo'
                    : '/admin/cod-payments/' + this.row.id + '/memo';
            },
        },
        methods: {
            /**
             * @param {Object} row 행 데이터
             * @param {String} focus 'req' | 'paid' — 커서를 먼저 둘 칸
             */
            open(row, focus) {
                this.row = row || null;
                this.inputReqMemo = row ? this.normalize(row.req_memo) : '';
                this.inputPaidMemo = row ? this.normalize(row.paid_memo) : '';
                this.show();

                // 모달 표시 애니메이션 뒤 포커스 (누른 비고 칸)
                let target = focus === 'paid' ? this.$refs.paidMemo : this.$refs.reqMemo;
                setTimeout(() => {
                    if (target) {
                        target.focus();
                    }
                }, 300);
            },

            submit() {
                if (this.busy || ! this.row) {
                    return;
                }
                this.request('patch', this.submitUrl, {
                    req_memo: this.inputReqMemo,
                    paid_memo: this.inputPaidMemo,
                }).then(this.done);
            },
        },
    }
</script>

<style lang="scss" scoped>
    // 시안 2026-10-09-6th 공용 모달 — 글자 1rem 이상 · 비고 구분 = 좌측 바 (대금상환비고 남색 / 창고지급비고 황갈)
    // (구 컨텍스트 4줄 .cdp-memo-ctx 그리드 = 사이클 16 #27 공용 app-buy-order-ctx 로 대체 — 여기 규칙을 두면 scoped 가 자식 루트에 닿으므로 삭제)

    .cdp-memo-field {
        display: grid;
        gap: 4px;
        margin-bottom: 12px;
        padding-left: 10px;
        border-left: 3px solid;

        &--req {
            border-color: #2b3a55;
        }

        &--paid {
            border-color: #9a5b00;
        }
    }

    .cdp-memo-field__label {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        gap: 4px 8px;
        font-weight: 500;
    }

    .cdp-memo-field__help {
        color: #6b7280;
        font-weight: 400;
    }

    .cdp-memo-foot {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
        margin-top: 6px;
    }

    .cdp-memo-foot__hint {
        color: #6b7280;
    }

    .cdp-memo-foot__btns {
        display: flex;
        gap: 8px;
        margin-left: auto;
    }
</style>
